import issueDescription from "./issue_description";
import reason from "./reason";

export default {
  issueDescription,
  reason,
  displayName: "Topic with Parameter Value in List",
  order: 120,
};
